import React from "react";
// ANT DESIGN COMPONENTS
// REDUX
import { useSelector } from "react-redux";
// INTERFACES
import { RootState } from "../../../app/store";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
import KeysAssignInterfaceBank from "./KeysAssignInterfaceBank";
// COMPONENTS
import KeysTable from "./KeysBankTable";
// INTERFACES

function KeysBankPage() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);
  const { permissionSet } = useSelector((state: RootState) => state.user);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <div className={`layout__contentPage__${theme}`}>
        {hasPermission(Permission.PermissionNotDefined, permissionSet ?? []) ? (
          <div>
            <KeysTable />
            <KeysAssignInterfaceBank />
          </div>
        ) : (
          <UnauthorizedPage />
        )}
      </div>
    </div>
  );
}

export default KeysBankPage;
